import UIPopper from "../popover";
import { List, ListItem, ListItemText } from "@mui/material";

const ActionPopover = ({
  handleClick,
  options = [],
  clickNode,
  disablePadding = false,
}) => {
  const clickItem = (e, closePopOver) => {
    closePopOver(null);
    handleClick(e);
  };

  return (
    <UIPopper
      // onClose={mapColumnsToCheckBox}
      paperStyles={{ p: 1 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      clickNode={clickNode}
    >
      {({ setAnchorEl }) => {
        return (
          <List sx={disablePadding ? { px: 1 } : {}}>
            {options.map((val, ind) => {
              return (
                <ListItem
                  disablePadding={disablePadding}
                  key={ind}
                  onClick={(e) => clickItem(val, setAnchorEl)}
                >
                  <ListItemText
                    className="cursor-pointer"
                    primary={val.title}
                  ></ListItemText>
                </ListItem>
              );
            })}

            {/* <UIListItem
              id={2}
              title={"Bulk Delete"}
              handleItemClick={(e) => clickItem(e, setAnchorEl)}
            /> */}
          </List>
        );
      }}
    </UIPopper>
  );
};

export default ActionPopover;
